import { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, FileText, Inbox, MessageSquare, CalendarDays, CalendarCheck, ShieldCheck, Bell, LogOut, Menu, X } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { useSeo } from "../../lib/hooks";
import { Brand } from "../site/SiteLayout";

export default function AppShell({ items, label }) {
  useSeo(label, "", true);
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = (
    <nav aria-label={label} className="flex flex-col gap-1 p-3">
      {items.map(([to, l, Icon, end]) => (
        <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)} data-testid={`side-${to.replace(/\//g, "-").slice(1)}`}
          className={({ isActive }) => `tap flex items-center gap-3 px-3 rounded-md text-sm font-medium transition-colors ${isActive ? "bg-white/10 text-white" : "text-white/75 hover:bg-white/5 hover:text-white"}`}>
          <Icon className="h-4 w-4 shrink-0" aria-hidden />{l}
        </NavLink>
      ))}
      <button onClick={logout} className="tap flex items-center gap-3 px-3 rounded-md text-sm font-medium text-white/75 hover:bg-white/5 mt-4" data-testid="logout-btn"><LogOut className="h-4 w-4" aria-hidden />Esci</button>
    </nav>
  );
  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[260px_1fr]">
      <a href="#main" className="skip-link">Vai al contenuto</a>
      <aside className="hidden lg:flex flex-col bg-primary text-primary-foreground sticky top-0 h-screen overflow-y-auto">
        <div className="p-5 border-b border-white/10"><Brand light /></div>
        {nav}
      </aside>
      <div className="min-w-0">
        <header className="sticky top-0 z-40 bg-background/95 backdrop-blur border-b">
          <div className="flex h-16 items-center justify-between px-4 sm:px-6 gap-3">
            <button className="lg:hidden tap min-w-[44px] grid place-items-center border rounded-md" aria-label="Apri menu" aria-expanded={open} onClick={() => setOpen(true)} data-testid="app-menu-toggle"><Menu className="h-5 w-5" /></button>
            <p className="text-sm text-muted-foreground truncate"><span className="eyebrow mr-2">{label}</span><span data-testid="current-user-email">{user?.email}</span></p>
            <Link to="/" className="text-sm underline shrink-0">Sito pubblico</Link>
          </div>
        </header>
        {open && <div className="lg:hidden fixed inset-0 z-50 bg-black/40" onClick={() => setOpen(false)}>
          <aside className="w-72 max-w-[85vw] h-full bg-primary text-primary-foreground overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-4 flex justify-between items-center border-b border-white/10"><Brand light /><button aria-label="Chiudi menu" className="tap min-w-[44px] grid place-items-center" onClick={() => setOpen(false)}><X /></button></div>{nav}
          </aside></div>}
        <main id="main" className="p-4 sm:p-6 lg:p-10 fade-up"><Outlet /></main>
      </div>
    </div>
  );
}

export const PORTAL_NAV = [
  ["/area-clienti", "Panoramica", LayoutDashboard, true], ["/area-clienti/documenti", "Documenti", FileText],
  ["/area-clienti/richieste", "Richieste", Inbox], ["/area-clienti/comunicazioni", "Comunicazioni", MessageSquare],
  ["/area-clienti/scadenze", "Scadenze", CalendarDays], ["/area-clienti/appuntamenti", "Appuntamenti", CalendarCheck],
  ["/area-clienti/sicurezza", "Sicurezza", ShieldCheck], ["/area-clienti/preferenze", "Notifiche", Bell],
];

export const Badge = ({ children, tone = "muted" }) => {
  const t = { muted: "bg-secondary text-foreground", gold: "bg-[hsl(var(--accent)/0.2)] text-[hsl(var(--gold-text))]", green: "bg-emerald-100 text-emerald-900", red: "bg-red-100 text-red-900", blue: "bg-blue-100 text-blue-900" }[tone];
  return <span className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${t}`}>{children}</span>;
};

export const STATUS = { richiesta: ["Richiesta", "gold"], ricevuta: ["Ricevuta", "blue"], in_verifica: ["In verifica", "blue"], completata: ["Completata", "green"],
  confermata: ["Confermata", "green"], rifiutata: ["Non accettata", "red"], proposta: ["Da riprogrammare", "gold"] };
export const StatusBadge = ({ s }) => { const [l, t] = STATUS[s] || [s, "muted"]; return <Badge tone={t}>{l}</Badge>; };
export const Empty = ({ children }) => <p className="card-line p-6 text-muted-foreground text-sm">{children}</p>;
